import { API_BASE_URL } from '../config';
import type {
  MonitoredSite,
  CreateSiteRequest,
  UpdateSiteRequest,
  SiteHistoryResponse
} from '../types';

export async function getSites(accessToken: string): Promise<MonitoredSite[]> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar sites');
  }

  const payload = await response.json();
  return payload.data || [];
}

export async function getSite(id: string, accessToken: string): Promise<MonitoredSite> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites/${id}`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar site');
  }

  const payload = await response.json();
  return payload.data;
}

export async function getSiteHistory(id: string, accessToken: string): Promise<SiteHistoryResponse> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites/${id}/history`, {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao carregar histórico');
  }

  const payload = await response.json();
  return payload.data;
}

export async function createSite(data: CreateSiteRequest, accessToken: string): Promise<MonitoredSite> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao criar site');
  }

  const payload = await response.json();
  return payload.data;
}

export async function updateSite(
  id: string,
  data: UpdateSiteRequest,
  accessToken: string
): Promise<MonitoredSite> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao atualizar site');
  }

  const payload = await response.json();
  return payload.data;
}

export async function deleteSite(id: string, accessToken: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao excluir site');
  }
}

export async function triggerCheck(id: string, accessToken: string): Promise<void> {
  const response = await fetch(`${API_BASE_URL}/monitor/sites/${id}/check`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => undefined);
    throw new Error(payload?.error?.message || 'Erro ao verificar site');
  }
}
